import React from "react";
import { motion } from "framer-motion";

function Incubations() {
  const partners = [
    { name: "iTIC IIT Hyderabad", type: "Incubated At", logo: "/partners/itic.png" },
    { name: "SIIC IIT Kanpur", type: "Incubated At", logo: "/partners/siic.png" },
    { name: "IIT Ropar", type: "Incubated At", logo: "/partners/ropar.png" },
    { name: "ABIF IIT Kharagpur", type: "Incubated At", logo: "/partners/abif.png" },
    { name: "Engineering College Bikaner", type: "Incubated & Collaborated", logo: "/partners/ecb.png" },
    { name: "SKRAU Bikaner", type: "Research Collaboration", logo: "/partners/skrau.png" },
  ];

  return (
    <div className="bg-[#050505] py-12 border-b border-gray-900 overflow-hidden relative">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#111_1px,transparent_1px),linear-gradient(to_bottom,#111_1px,transparent_1px)] bg-[size:2rem_2rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-50"></div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <p className="text-center text-xs font-mono font-bold text-gray-500 uppercase tracking-[0.3em] mb-10">
          Incubated At & Research Partners
        </p>
        
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 md:gap-x-16 lg:gap-x-20">
          {partners.map((partner, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="flex flex-col items-center justify-center text-center group"
            >
              {/* Optional Logo (Will hide if image doesn't exist in public/partners folder) */}
              <img 
                src={partner.logo} 
                alt={partner.name}
                onError={(e) => e.target.style.display = 'none'}
                className="h-14 w-auto object-contain mb-3 grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 hover:scale-110 drop-shadow-sm group-hover:drop-shadow-lg"
              />
              
              <span className="text-lg md:text-xl font-bold font-sans text-gray-400 group-hover:text-white transition-colors duration-300">
                {partner.name}
              </span>
              <span className="text-[10px] font-mono text-gray-600 tracking-widest uppercase mt-1">
                {partner.type}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Incubations;
